import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import {
  ComplianceTracking,
  ComplianceTrackingService,
} from "@/core/services/api/interfaces/manager/ComplianceTracking";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import { KYCFile } from "@/core/services/api/interfaces/manager/KYCFile";

@Module
export default class ComplianceTrackingsModule extends VuexModule {
  list = new PaginationResponse<ComplianceTracking>();

  get complianceTrackingsPagination(): PaginationResponse<ComplianceTracking> {
    return this.list;
  }

  get complianceTrackings(): ComplianceTracking[] {
    return this.list.data;
  }

  get complianceTrackingsFirst(): null | ComplianceTracking {
    return 0 in this.list.data ? this.list.data[0] : null;
  }

  get complianceTrackingsByService() {
    return (service: ComplianceTrackingService): ComplianceTracking[] =>
      this.list.data.filter(
        (value: ComplianceTracking) => value.service === service
      );
  }

  get complianceTrackingsByServiceCount() {
    return (service: ComplianceTrackingService): number => {
      const cts = this.complianceTrackingsByService(service);
      console.log(service, cts);

      return cts.length;
    };
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPLIANCE_TRACKINGS_LOAD]({
    entity,
    entity_id,
    get_parameters = {},
  }) {
    return ApiService.manager.kyc
      .collection(entity, entity_id, get_parameters)
      .then(ApiService.unwrapPaginationResponse)
      .then((pagination) => {
        this.context.commit(
          Mutations.MANAGER_COMPLIANCE_TRACKINGS_SET,
          pagination
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPLIANCE_TRACKINGS_LOAD
        );
      });
  }

  @Mutation
  [Mutations.MANAGER_COMPLIANCE_TRACKINGS_SET](pagination) {
    this.list = pagination;
  }

  @Mutation
  [Mutations.MANAGER_COMPLIANCE_TRACKINGS_RESET]() {
    this.list = new PaginationResponse<ComplianceTracking>();
  }

  @Mutation
  async [Mutations.MANAGER_COMPLIANCE_TRACKINGS_REPLACE](
    compliance: ComplianceTracking
  ) {
    for (const i in this.list.data) {
      if (!this.list.data[i]) {
        continue;
      }
      if (this.list.data[i].id !== compliance.id) {
        continue;
      }
      this.list.data[i] = Object.assign(this.list.data[i], compliance);

      return;
    }

    this.list.data.push(compliance);
  }

  @Mutation
  async [Mutations.MANAGER_COMPLIANCE_TRACKINGS_FILE_REPLACE](file: KYCFile) {
    const list = this.list.data;
    let isFound = false;
    for (const i in list) {
      if (!list[i]) {
        continue;
      }
      if (!list[i].files) {
        continue;
      }
      const files = list[i].files;
      for (const d in files) {
        if (!(d in files)) {
          continue;
        }
        let current = files[d];
        console.log(current.id, file.id);
        if (current.id !== file.id) {
          continue;
        }
        current = Object.assign(current, file);
        isFound = true;
      }
      const col = "required_files_bunches";
      if (!(col in list[i])) {
        continue;
      }
      const bunches = list[i][col];
      for (const b in bunches) {
        if (!(b in bunches)) {
          continue;
        }
        const files = bunches[b];
        for (const f in files) {
          let current = files[f];
          console.log(current.id, file.id);
          if (current.id !== file.id) {
            continue;
          }
          current = Object.assign(current, file);
        }
      }
    }

    if (!isFound) {
      for (const i in list) {
        if (!list[i]) {
          continue;
        }
        const compliance = list[i];
        if (compliance.id === file.compliance_tracking_id) {
          if (!compliance.files) {
            compliance.files = [];
          }
          compliance.files.push(file);
        }
      }
    }
  }
}
